module.exports = __webpack_public_path__ + "img/fac1.f1f488ec.png";